import Axios from "../api/axios";
import config from "../../config";

const getCclPage = (page) => {
  return Axios.get(`${config.BASE_URL}ccl-pages?filters[Slug][$eq]=${page}&populate=*`);
};

export default getCclPage;
